module.exports = __webpack_public_path__ + "media/es-gibt-noch-viel-zu-entdecken.3e8ad188.mp3";